<template>
    <m-pageframe title="Edit App">
        <v-container v-if="meta_data != null">

            <m-edit-text
                label="Application Id (app id)"
                v-model="meta_data.app_id"
                read_only
            />

            <m-edit-text
                label="Version Number"
                v-model="meta_data.version"
                read_only
            />

            <m-edit-textarea
                label="Latest Version Release Notes (markdown)"
                v-model="meta_data.changelog_md"
                :read_only="readonly"
                v-on:input="save"
            />

            <v-select
                label="State"
                :items="state_choices"
                v-model="meta_data.state"
                :readonly="readonly"
                v-on:change="save"
            />

            <m-edit-blobs
                label="Logo (.png with 1/1 aspect ratio recommended)"
                v-model="meta_data.logo_blob_ids"
                :process_media="true"
                :externally_visible="true"
                :accept="['png', 'jpg', 'jpeg']"
                empty_text="No logo"
                :read_only="readonly"
                :allow_multiple="false"
                v-on:input="save"
            />

            <m-edit-blobs
                label="Feature Images (16/9 aspect ratio recommended)"
                v-model="meta_data.feature_image_blob_ids"
                :process_media="true"
                :externally_visible="true"
                :accept="['png', 'jpg', 'jpeg']"
                empty_text="No feature images"
                :read_only="readonly"
                :allow_multiple="true"
                v-on:input="save"
            />

            <m-edit-text
                label="App Label"
                v-model="meta_data.app_label"
                :read_only="readonly"
                v-on:input="save"
            />

            <m-edit-textarea
                label="Short Description"
                v-model="meta_data.app_description_short_md"
                :read_only="readonly"
                v-on:input="save"
            />

            <m-edit-textarea
                label="Long Description (markdown)"
                v-model="meta_data.app_description_long_md"
                :read_only="readonly"
                v-on:input="save"
            />

            <div style="font-size: 13px; color: #B1B1B1; margin-bottom: -15px">
                Permissions
            </div>

            <v-checkbox
                v-for="(item, index) in $rc.enumValues('app_permission')"
                :key="'permission' + index"
                :label="item.text"
                style="margin-bottom: -25px"
                v-model="meta_data.permissions"
                :value="item.value"
                v-on:change="save"
                :readonly="meta_data.state == 'approved'"
                :disabled="meta_data.state == 'approved'"
            />

            <div style="height: 30px">
            </div>

            <m-edit-text
                label="After Install Dialog Title"
                v-model="meta_data.after_install_title"
                :read_only="readonly"
                v-on:input="save"
            />

            <m-edit-textarea
                label="After Install Dialog Content (markdown)"
                v-model="meta_data.after_install_detail_md"
                :read_only="readonly"
                v-on:input="save"
            />

            <div style="text-align: right">
                <v-btn v-on:click="onClickAfterInstallDialog">
                    Preview After Install Dialog...
                </v-btn>
            </div>

            <v-select
                label="Installable (once approved) by organizations in the following industries"
                :items="$rc.enumValues('industry_code')"
                v-model="meta_data.available_to_industry_codes"
                multiple
                :readonly="readonly"
                v-on:change="save"
            />

            <v-select
                label="Available to be installed (for testing) to the following organizations"
                :items="available_to_organization_labels"
                v-model="meta_data.available_to_organization_ids"
                multiple
                :readonly="readonly"
                v-on:change="save"
                chips
            />

            <div
                v-if="this.$rc.$state.isAuthActorSystemAdmin()"
                style="text-align: right"
            >
                <v-btn v-on:click="onClickAddOrg">
                    Add Organization...
                </v-btn>
            </div>



        </v-container>
    </m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            meta_data: null,
            available_to_organization_labels: null,
        }
    },

    mounted() {
        this.doUpdate();
    },

    methods: {
        doUpdate() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/apps/my-apps/profile/:app_id/:version',

                'params': {
                    'app_id': this.$route.params.app_id,
                    'version': this.$route.params.version,
                },

                'on_success': (data) => {
                    this.updateData(data);
                },

                'on_error': 'Unable to get app profile',
            });
        },

        save() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/apps/my-apps',

                'params': this.meta_data,

                'on_success': (data) => {
                    this.updateData(data);
                },

                'on_error': 'Unable to complete API call',
            });
        },

        updateData(data) {
            this.meta_data = data.meta_data;
            this.available_to_organization_labels = data.available_to_organization_labels;
        },

        onClickAddOrg() {
            this.$rc.prompt({
                'title': 'Add (Testing) Organization Id',
                'label': 'Add the organization id to allow to installed this app for testing',
                'value': null,
                'unset_label': null,

                'after_prompt': (value) => {
                    this.meta_data.available_to_organization_ids.push(value);
                    this.save();
                },
            });
        },

        onClickAfterInstallDialog() {
            this.$rc.alertMarkdown(this.meta_data.after_install_title, this.meta_data.after_install_detail_md);
        },

    },

    computed: {
        readonly() {
            if (this.meta_data == null)
                return true;

            if (this.$rc.$state.isAuthActorSystemAdmin())
                return false;

            return this.meta_data.state == 'approved';
        },

        state_choices() {

            let ret = this.$rc.enumValues('app_state')
                .map(item => {

                    if (item.value == 'approved')
                        item.disabled = !this.$rc.$state.isAuthActorSystemAdmin();

                    return item;
                });

            return ret;
        },


    },
}
</script>

<style lang="scss" scoped></style>